module.exports = __webpack_public_path__ + "static/img/left-tip.ed3b71e9.png";